export function getBackend() {
  if (process.env.NODE_ENV === "development") {
    return "https://socialmediaplanner.local:8080";
  }

  return "https://api.socialmediaplanner.photography";
}
